/**
 * 平台安全管理模块相关常量
 */

/** 处理状态 */
export const HANDLE_STATUS = {
  /** 通过 */
  PASS: 'PASS',
  /** 拒绝 */
  REFUSE: 'REFUSE',
}

/** 处理状态的中文映射 */
export const HANDLE_STATUS_CN = {
  [HANDLE_STATUS.PASS]: '通过',
  [HANDLE_STATUS.REFUSE]: '拒绝',
}

/** 处理状态的下拉选项 */
export const HANDLE_STATUS_OPTIONS = [
  /** 未处理 (该选项仅用于筛选) */
  {
    label: '未处理',
    value: '',
  },
  /** 通过选项 */
  {
    label: HANDLE_STATUS_CN[HANDLE_STATUS.PASS],
    value: HANDLE_STATUS.PASS,
  },
  /** 拒绝选项 */
  {
    label: HANDLE_STATUS_CN[HANDLE_STATUS.REFUSE],
    value: HANDLE_STATUS.REFUSE,
  },
]

/** 投诉类型 */
export const COMPLAINT_TYPE = {
  /** 用户违规 */
  USER_VIOLATION: 'USER_VIOLATION',
  /** 机构违规 */
  ORG_VIOLATION: 'ORG_VIOLATION',
  /** 内容违规 */
  CONTENT_VIOLATION: 'CONTENT_VIOLATION',
  /** 其他 */
  OTHER: 'OTHER',
}

/** 投诉类型的中文映射 */
export const COMPLAINT_TYPE_CN = {
  [COMPLAINT_TYPE.USER_VIOLATION]: '用户违规',
  [COMPLAINT_TYPE.ORG_VIOLATION]: '机构违规',
  [COMPLAINT_TYPE.CONTENT_VIOLATION]: '内容违规',
  [COMPLAINT_TYPE.OTHER]: '其他',
}

/** 投诉类型的下拉选项 */
export const COMPLAINT_TYPE_OPTIONS = [
  /** 用户违规选项 */
  {
    label: COMPLAINT_TYPE_CN[COMPLAINT_TYPE.USER_VIOLATION],
    value: COMPLAINT_TYPE.USER_VIOLATION,
  },
  /** 机构违规选项 */
  {
    label: COMPLAINT_TYPE_CN[COMPLAINT_TYPE.ORG_VIOLATION],
    value: COMPLAINT_TYPE.ORG_VIOLATION,
  },
  /** 内容违规选项 */
  {
    label: COMPLAINT_TYPE_CN[COMPLAINT_TYPE.CONTENT_VIOLATION],
    value: COMPLAINT_TYPE.CONTENT_VIOLATION,
  },
  /** 其他选项 */
  {
    label: COMPLAINT_TYPE_CN[COMPLAINT_TYPE.OTHER],
    value: COMPLAINT_TYPE.OTHER,
  },
]

/** 投诉原因 */
export const COMPLAINT_REASON = {
  /** 虚假信息 */
  FALSE: 'FALSE',
  /** 骚扰广告 */
  HARASSMENT: 'HARASSMENT',
  /** 诈骗 */
  FRAUD: 'FRAUD',
  /** 辱骂 */
  ABUSE: 'ABUSE',
  /** 低俗 */
  VULGAR: 'VULGAR',
  /** 其他 */
  OTHER: 'OTHER',
}

/** 投诉原因的中文映射 */
export const COMPLAINT_REASON_CN = {
  [COMPLAINT_REASON.FALSE]: '虚假信息',
  [COMPLAINT_REASON.HARASSMENT]: '骚扰广告',
  [COMPLAINT_REASON.FRAUD]: '诈骗/托',
  [COMPLAINT_REASON.ABUSE]: '不文明/辱骂/骚扰',
  [COMPLAINT_REASON.VULGAR]: '色情低俗',
  [COMPLAINT_REASON.OTHER]: '其他',
}

/** 投诉原因的下拉选项 */
export const COMPLAINT_REASON_OPTIONS = [
  /** 虚假信息选项 */
  {
    label: COMPLAINT_REASON_CN[COMPLAINT_REASON.FALSE],
    value: COMPLAINT_REASON.FALSE,
  },
  /** 骚扰广告选项 */
  {
    label: COMPLAINT_REASON_CN[COMPLAINT_REASON.HARASSMENT],
    value: COMPLAINT_REASON.HARASSMENT,
  },
  /** 诈骗选项 */
  {
    label: COMPLAINT_REASON_CN[COMPLAINT_REASON.FRAUD],
    value: COMPLAINT_REASON.FRAUD,
  },
  /** 辱骂选项 */
  {
    label: COMPLAINT_REASON_CN[COMPLAINT_REASON.ABUSE],
    value: COMPLAINT_REASON.ABUSE,
  },
  /** 低俗选项 */
  {
    label: COMPLAINT_REASON_CN[COMPLAINT_REASON.VULGAR],
    value: COMPLAINT_REASON.VULGAR,
  },
  /** 其他选项 */
  {
    label: COMPLAINT_REASON_CN[COMPLAINT_REASON.OTHER],
    value: COMPLAINT_REASON.OTHER,
  },
]

/** 申诉类型 */
export const APPEAL_TYPE = {
  /** 解除账号限制 */
  ACCOUNT_RESTRICTION: 'ACCOUNT_RESTRICTION',
  /** 解除发布限制 */
  PUBLISH_RESTRICTION: 'PUBLISH_RESTRICTION',
  /** 其他 */
  OTHER: 'OTHER',
}

/** 申诉类型的中文映射 */
export const APPEAL_TYPE_CN = {
  [APPEAL_TYPE.ACCOUNT_RESTRICTION]: '解除账号限制',
  [APPEAL_TYPE.PUBLISH_RESTRICTION]: '解除发布限制',
  [APPEAL_TYPE.OTHER]: '其他',
}

/** 申诉类型的下拉选项 */
export const APPEAL_TYPE_OPTIONS = [
  /** 解除账号限制选项 */
  {
    label: APPEAL_TYPE_CN[APPEAL_TYPE.ACCOUNT_RESTRICTION],
    value: APPEAL_TYPE.ACCOUNT_RESTRICTION,
  },
  /** 解除发布限制选项 */
  {
    label: APPEAL_TYPE_CN[APPEAL_TYPE.PUBLISH_RESTRICTION],
    value: APPEAL_TYPE.PUBLISH_RESTRICTION,
  },
  /** 其他选项 */
  {
    label: APPEAL_TYPE_CN[APPEAL_TYPE.OTHER],
    value: APPEAL_TYPE.OTHER,
  },
]

/** 申诉原因 */
export const APPEAL_REASON = {
  /** 账号被盗用 */
  ACCOUNT_HIJACKED: 'ACCOUNT_HIJACKED',
  /** 误操作导致 */
  MISTAKE_OPERATION: 'MISTAKE_OPERATION',
  /** 系统误判 */
  SYSTEM_ERROR: 'SYSTEM_ERROR',
  /** 其他 */
  OTHER: 'OTHER',
}

/** 申诉原因的中文映射 */
export const APPEAL_REASON_CN = {
  [APPEAL_REASON.ACCOUNT_HIJACKED]: '账号被盗用',
  [APPEAL_REASON.MISTAKE_OPERATION]: '误操作导致',
  [APPEAL_REASON.SYSTEM_ERROR]: '系统误判',
  [APPEAL_REASON.OTHER]: '其他',
}

/** 申诉原因的下拉选项 */
export const APPEAL_REASON_OPTIONS = [
  /** 账号被盗用选项 */
  {
    label: APPEAL_REASON_CN[APPEAL_REASON.ACCOUNT_HIJACKED],
    value: APPEAL_REASON.ACCOUNT_HIJACKED,
  },
  /** 误操作导致选项 */
  {
    label: APPEAL_REASON_CN[APPEAL_REASON.MISTAKE_OPERATION],
    value: APPEAL_REASON.MISTAKE_OPERATION,
  },
  /** 系统误判选项 */
  {
    label: APPEAL_REASON_CN[APPEAL_REASON.SYSTEM_ERROR],
    value: APPEAL_REASON.SYSTEM_ERROR,
  },
  /** 其他选项 */
  {
    label: APPEAL_REASON_CN[APPEAL_REASON.OTHER],
    value: APPEAL_REASON.OTHER,
  },
]
